import BaseView from './base-view.js';
import ProjectUtil from '../utils/project-util.js';
//import bodyTemplate from '../../handlebars/client/posts-list-vertical-body.hbs';
//import imgTemplate from '../../handlebars/client/posts-list-vertical-img.hbs';

class VerticalPostsList extends BaseView {
	//el() {  } // in footer 

	events() {
		return {
			'click .content-btn-list-btn': 'handleContentBtnListBtnClick',
		};
	}

	postInitialize() { return {}; }

	bindings() { return {}; }

	listeners() {
		return {};
	}

	async setTemplate() {
		const [bodyTemplateModule, imgTemplateModule] = await Promise.all([
			import(/* webpackChunkName: "posts-list-vertical-body" */ '../../handlebars/client/posts-list-vertical-body.hbs'),
			import(/* webpackChunkName: "posts-list-vertical-img" */ '../../handlebars/client/posts-list-vertical-img.hbs')
		]);
		this.bodyTemplate = bodyTemplateModule.default;
		this.imgTemplate = imgTemplateModule.default;
	}

	async postRender() {
		await this.setTemplate();
		const self = this;
		// vars
		//this.moduleDataObj = ProjectUtil.getObjByProp(this.model.get('page').content.modules, 'id', this.$el.data('mod-id'));
		this.moduleDataObj = ProjectUtil.getObjByProp(this.model.get('page').content.modules, 'id', this.$el.data('mod-id'));
		this.$curBtn = $('.content-btn-list-btn.showing', this.$el);
		this.$bodyDest = $('.body-content', this.$el);
		this.$imgDest = $('.post-img-wrap', this.$el);

		return self;
	}

	handleContentBtnListBtnClick(e) {
		const $tBtn = $(e.currentTarget);
		if ($tBtn.hasClass('showing')) {
			// this is the active button, so exit
			return;
		}
		// get the data object from the button's data-id attribute
		const tPostId = $tBtn.data('id');
		const tPostData = ProjectUtil.getObjByProp(this.moduleDataObj.results.items, 'id', tPostId);

		// update body content
		this.$bodyDest.html(this.bodyTemplate({ item: tPostData }));
		// update image content
		this.$imgDest.html(this.imgTemplate({ item: tPostData }));

		// update current button
		this.$curBtn.removeClass('showing');
		this.$curBtn.parent().removeClass('showing');
		// update aria states
		this.$curBtn.attr('aria-expanded', 'false');
		this.$curBtn.attr('aria-disabled', 'false');
		this.$curBtn.attr('disabled', false);

		this.$curBtn = $tBtn;
		this.$curBtn.addClass('showing');
		this.$curBtn.parent().addClass('showing');
		// update aria states
		this.$curBtn.attr('aria-expanded', 'true');
		this.$curBtn.attr('aria-disabled', 'true');
		this.$curBtn.attr('disabled', true);
	}

	cleanup() {

	}
}

export default VerticalPostsList;